import { METADATA_CMS_IDS } from 'js/constants/Pages';

export const parseMetaData = (metadata) => {
  const allIDs = [];
  const byID = {};

  for (const key in METADATA_CMS_IDS) {
    const page = METADATA_CMS_IDS[key];
    const meta = {};
    const data = metadata[page] || {};

    const {
      og_image = DEFAULT_METADATA.og_image,
      meta_title = DEFAULT_METADATA.meta_title,
      meta_description = DEFAULT_METADATA.meta_description,
      og_description = DEFAULT_METADATA.og_description,
      meta_keywords = DEFAULT_METADATA.meta_keywords,
      og_sitename = DEFAULT_METADATA.og_sitename,
      og_title = DEFAULT_METADATA.og_title,
      og_type = DEFAULT_METADATA.og_type,
      og_url = DEFAULT_METADATA.og_url,
    } = data;

    const og_image_src = og_image !== '' ? `${metadata[page].og_image}` : '';

    meta.title = meta_title == '' || meta_title == null ? DEFAULT_METADATA.meta_title : meta_title;
    meta.description =
      meta_description == '' || meta_description == null ? DEFAULT_METADATA.meta_description : meta_description;
    meta.keywords = meta_keywords == '' || meta_keywords == null ? DEFAULT_METADATA.meta_keywords : meta_keywords;
    meta.og_description =
      og_description == '' || og_description == null ? DEFAULT_METADATA.og_description : og_description;
    meta.og_image = og_image_src === '' ? DEFAULT_METADATA.og_image : og_image_src;
    meta.og_sitename = og_sitename == '' || og_sitename == null ? DEFAULT_METADATA.og_sitename : og_sitename;
    meta.og_title = og_title == '' || og_title == null ? DEFAULT_METADATA.og_title : og_title;
    meta.og_type = og_type == '' || og_type == null ? DEFAULT_METADATA.og_type : og_type;
    meta.og_url = og_url == '' || og_url == null ? DEFAULT_METADATA.og_url : og_url;
    meta.isConfigured = Object.values(data).some((value) => value !== '' && value !== null);
    byID[page] = meta;
    allIDs.push(page);
  }

  return { allIDs, byID };
};

const DEFAULT_METADATA = {
  og_image: '',
  meta_title: 'Stan and Gran',
  meta_description:
    'Explore Stan & Gran – a funny, nature-packed mystery show for kids aged 4–7. Watch clips, meet the characters, and learn about wildlife.',
  og_description: 'Welcome to the Stan and Gran website.',
  meta_keywords: '',
  og_sitename: 'Stan and Gran',
  og_title: 'Stan and Gran',
  og_type: 'website',
  og_url: window.siteData?.base_url || '',
};
